<script setup>
import { computed, onMounted, ref } from 'vue';
import { useAuthStore } from "@/app/stores/authStore";

// Components
import EmployeesWithBirthdays from '@/components/shared/Home/EmployeesWithBirthdays.vue';

// Services
import HolidayService from "@/api/services/holiday.service";

const authStore = useAuthStore();

const showDialogBirthday = ref(false);
// Computed
const user = computed(() => authStore.getUserLogged);


const birthdays = ref([])

onMounted(() => {
    getBirthdays();
})

const getBirthdays = () => {
    HolidayService.getNextBirthDays(user.value.id).then((res) => {
        birthdays.value = res.data.data;
    })
}

const openDialogBirthdays = () => {
    showDialogBirthday.value = true;
}

const formatDate = (text) => {
    if (!text) return '';
    text = text.trim();
    const parts = text.split(' ');
    if (parts.length === 2) {
        const [day, month] = parts;
        return `${day} DE ${month.toUpperCase()}`;
    }
    return text.toUpperCase();
}

</script>

<template>
    <div>
        <el-card class="box-card" body-style="padding:10px; background-color: #F9156F">
            <div class="f-flex align-items-center justify-content-start full-card mb-2">
                <div class="card-icon d-flex justify-content-start align-items-center header col-12 mb-2">
                    <img class="birthday-icon" src="@/assets/icons/cake-white.svg" alt="cake-icon" width="47"
                        height="47">
                    <span class="card-title">Cumpleaños</span>
                </div>
                <div class="row col-12 justify-content-start align-items-start" v-if="birthdays.length <= 0">
                    <span class="text-birthday">
                        No hay cumpleaños cerca
                    </span>
                </div>
                <div v-if="birthdays.length > 0" class="birthday">
                    <div v-for="(birthday, index) in birthdays" :key="birthday.id" class="birthday-item">
                        <div class="birthday-info text-birthday">
                            {{ formatDate(birthday.day) }} {{ birthday.name }}
                        </div>

                        <el-divider v-if="index < birthdays.length - 1" class="divider" />
                    </div>
                </div>
                <div class="col-12 d-flex justify-content-end align-items-center">
                    <button class="btn btn_yellow align-self-end justify-content-end btn-plus-birthdays"
                        @click="openDialogBirthdays">+</button>
                </div>
            </div>
        </el-card>
        <!-- Dialog show full Birthdays -->
        <el-dialog v-model="showDialogBirthday" :show-close="false" width="90%" style="max-width: 900px;"
            :style="{ borderRadius: `var(--el-border-radius-round)` }">
            <div class="my-header">
                <svg id="asterisk" xmlns="http://www.w3.org/2000/svg" width="724" height="1024" viewBox="0 0 724 1024">
                    <path
                        d="M0 499.8l59-181.7 332.5 108.6-59 180.8-332.5-107.7zM79.6 744.3l206.1-282.9 154.5 111.5-206.1 283.8-154.5-112.4zM266.9 167.3h191.1v350.3h-191.1v-350.3zM285.6 572.9l154.5-111.5 206.1 282.9-154.5 112.4-206.1-283.8zM332.5 426.8l332.5-108.6 59 181.7-331.6 107.7-59.9-180.8z" />
                </svg>
                <span class="text-header ml-5 mt-3"> Cumpleaños</span>
                <img class="close-icon pointer" src="@/assets/images/aspa_blue_small_entrada.png" alt=""
                    @click="showDialogBirthday = false">
            </div>
            <EmployeesWithBirthdays :happy-verde="birthdays" />
        </el-dialog>
    </div>
</template>

<style lang="scss" scoped>
.box-card {
    border-radius: 12px;
    color: white;
    margin-bottom: 15px;
}

.full-card {
    margin-left: 15px;
}

.header {
    min-width: 220px;
    width: 20%;
    height: 100%;

    span {
        letter-spacing: -0.05em;
        font-size: 1.3em;
        font-weight: bolder;
    }

    .card-title {
        margin: 0 10px;
        font-weight: 800;
        letter-spacing: -0.05em;
        font-size: 40px;
    }
}

.text-birthday {
    font-size: 16px;
    font-weight: 500;
}

.person-item {
    margin-bottom: 8px;
}

.divider {
    margin: 6px 0;
}

.btn-plus-birthdays {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    font-size: 20px;
    font-weight: 700;
    line-height: 1;
    padding: 0;
}

@media screen and (max-width: 720px) {
    .my-header {
        .text-header {
            font-size: 2em !important;
            margin-left: 30px;
            margin-top: 0 !important;
        }

        #asterisk {
            width: 1.9em !important;
        }
    }
}
@media (max-height: 790px),
(max-width: 860px) {
    .header {
        .card-title {
            font-size: 30px;
        }
    }
}
</style>
